import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X2AgeCategoryUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddAgeCategoryStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly languageId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;

    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X2AgeCategoryUpdateModel = {
      LanguageId: this.languageId,
      Name: this.name.value
    };
    this.save = contentLoaders.x2ageCategory.insert(model);
  }
}
